(function () {
    document.addEventListener("click", (event) => {
        const hamburger = event.target.closest(".hamburger");

        if (hamburger && hamburger.classList.contains("hamburger")) {
            hamburger.classList.toggle("active");
        }
    });
})();
